import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import CardExportFooter from '~/components/export/CardFooter.vue';
import CardExportHeader from '~/components/export/CardHeader.vue';
import { EXPORT_MAX_SCALE, EXPORT_MIN_SCALE, useScaleToFit } from '~/functions/export-scale';
export default /*#__PURE__*/_defineComponent({
  __name: 'CardScaled',
  props: {
    minScale: {
      type: Number,
      default: EXPORT_MIN_SCALE
    },
    absoluteMinScale: {
      type: Number,
      default: undefined
    },
    companyName: {
      type: String,
      required: true
    },
    exportedAt: {
      type: [Date, String, Number],
      required: true
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var frameRef = ref(null);
    var contentRef = ref(null);
    var _useScaleToFit = useScaleToFit(frameRef, contentRef, {
        maxScale: EXPORT_MAX_SCALE,
        minScale: props.minScale,
        absoluteMinScale: props.absoluteMinScale
      }),
      contentStyle = _useScaleToFit.contentStyle,
      recalculate = _useScaleToFit.recalculate;
    var scalerStyle = computed(function () {
      return {
        width: '100%'
      };
    });
    onMounted(function () {
      window.addEventListener('beforeprint', recalculate);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('beforeprint', recalculate);
    });
    expose({
      recalculate: recalculate
    });
    return {
      __sfc: true,
      props: props,
      frameRef: frameRef,
      contentRef: contentRef,
      contentStyle: contentStyle,
      recalculate: recalculate,
      scalerStyle: scalerStyle,
      CardExportFooter: CardExportFooter,
      CardExportHeader: CardExportHeader
    };
  }
});